import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { ADMIN_GLOBAL_CONFIG } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
/**
 * list Global Configuration.
 * @returns {Promise} - A promise that resolves with the list of Global Configuration or rejects with an error.
 * @param props
 */
export const listGlobalConfiguration = async ({
  accessToken,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const response = await apiServiceWrapper({
    url: `${ADMIN_GLOBAL_CONFIG}/GetAllGlobalConfigs`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    GlobalConfigurations: response.Payload,
    TotalCount: response.Payload?.length,
  };
};

/**
 * Create Global Configuration.
 * @returns {Promise} - A promise that resolves with the creation of Profile Group or rejects with an error.
 * @param data
 */
export const createGlobalConfiguration = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_GLOBAL_CONFIG}/AddGlobalConfig`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Global Configuration.
 * @returns {Promise} - A promise that resolves with the update of Profile Group or rejects with an error.
 * @param data
 */
export const updateGlobalConfiguration = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_GLOBAL_CONFIG}/UpdateGlobalConfig`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * delete the Global Configuration.
 * @returns {Promise} - A promise that resolves with the delete of blob or rejects with an error.
 * @param data
 */
export const deleteGlobalConfiguration = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_GLOBAL_CONFIG}/DeleteGlobalConfig?configId=${data?.ConfigId}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * get Global Configuration.
 * @returns {Promise} - A promise that resolves with the Global Configuration or rejects with an error.
 * @param data
 */
export const getGlobalConfiguration = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_GLOBAL_CONFIG}/GetGlobalConfigById?configId=${data?.ConfigId}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};

/**
 * get Global Configuration.
 * @returns {Promise} - A promise that resolves with the Global Configuration or rejects with an error.
 * @param data
 */
export const getEncryptDecryptData = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
  isEncrypt,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ADMIN_GLOBAL_CONFIG}/${isEncrypt ? 'Encrypt' : 'Decrypt'}`,
    method: 'POST',
    body: data,
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};

